import * as styles from './PageTitle.css';
import { Link } from '../Link';

interface IPageTitleProps {
  newbuildingName: string;
  newbuildingUrl: string;
}

export const PageTitle = (props: IPageTitleProps) => {
  const intro = 'Планировки ';

  return (
    <h1 className={styles['title']}>
      {intro}
      <span className={styles['title--link-block']}>
        в&nbsp;
        <Link target="_blank" url={props.newbuildingUrl}>
          {props.newbuildingName}
        </Link>
      </span>
    </h1>
  );
};
